/**
 * Calculate centroid of a GeoJSON geometry
 */
export const calculateCentroid = geometry => {
  if (!geometry || !geometry.coordinates) return null

  let totalLat = 0
  let totalLon = 0
  let pointCount = 0

  const addPoints = coords => {
    if (Array.isArray(coords[0])) {
      coords.forEach(addPoints)
    } else {
      totalLon += coords[0]
      totalLat += coords[1]
      pointCount++
    }
  }

  if (geometry.type === 'Polygon') {
    addPoints(geometry.coordinates[0])
  } else if (geometry.type === 'MultiPolygon') {
    geometry.coordinates.forEach(polygon => addPoints(polygon[0]))
  }

  if (pointCount === 0) return null

  return {
    lat: totalLat / pointCount,
    lon: totalLon / pointCount,
  }
}
